import React, { Component } from 'react';

import StateLoading from '../components/Layout/StateLoading';

/**
 * Returns a new React component, ready to be instantiated.
 * Note the closure here protecting Component, and providing a unique
 * instance of Component to the static implementation of `load`.
 */
export const asyncComponent = ({ loader }) => {
  let Generated = null;

  return class AsyncRouteComponent extends Component {
    state = {
      Generated,
    };

    /**
     * Static so that you can call load against an uninstantiated version of
     * this component. This should only be called one time outside of the
     * normal render path.
     */
    static load = async () => {
      if (!Generated) {
        const ResolvedComponent = await loader();
        Generated = (ResolvedComponent || {}).default || ResolvedComponent;
      }
    };

    static getInitialProps(...args) {
      // Need to call the wrapped components getInitialProps if it exists
      if (Generated) {
        return Generated.getInitialProps
          ? Generated.getInitialProps(...args)
          : Promise.resolve(null);
      }
    }

    componentDidMount() {
      AsyncRouteComponent.load().then(this.updateState);
    }

    updateState = () => {
      // Only update state if we don't already have a reference to the
      // component, this prevent unnecessary renders.
      if (this.state.Generated !== Generated) {
        this.setState({
          Generated,
        });
      }
    };

    render() {
      const { Generated } = this.state;

      if (Generated) {
        return <Generated {...this.props} />;
      }

      return <StateLoading />;
    }
  };
};
